<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Cajón lateral: solo en pantallas pequeñas, donde el menú horizontal no alcanza -->
<ng-container *ngIf="isScreenSmall">
    <fuse-vertical-navigation
        class="dark bg-primary print:hidden"
        [mode]="'over'"
        [name]="'mainNavigation'"
        [navigation]="navegacionMovil"
        [opened]="false">
        <!-- Navigation header hook -->
        <ng-container fuseVerticalNavigationContentHeader>
            <div class="flex items-center h-20 pt-6 px-8">
                <img class="w-28 cursor-pointer" src="assets/images/logo/hurclick-logo-white.svg" alt="Hurclick" routerLink="/home">
            </div>
        </ng-container>
    </fuse-vertical-navigation>
</ng-container>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">

    <!-- Header -->
    <div class="relative flex flex-0 items-center w-full h-16 sm:h-20 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-primary dark:bg-transparent print:hidden">
        <!-- Pantallas pequeñas: botón del cajón y logo para volver al inicio -->
        <ng-container *ngIf="isScreenSmall">
            <button mat-icon-button (click)="toggleNavigation('mainNavigation')" aria-label="Abrir menú">
                <mat-icon class="text-white" [svgIcon]="'heroicons_outline:menu'"></mat-icon>
            </button>
            <img alt="Hurclick" class="w-24 ml-2 cursor-pointer"
                src="assets/images/logo/hurclick-logo-white.svg" routerLink="/home">
        </ng-container>

        <ng-container *ngIf="!isScreenSmall">
            <!-- Logo -->
            <div class="flex items-center mx-2 lg:mr-8">
                <div class="hidden lg:flex">
                    <img alt="logo"
                        class="dark:hidden w-24 cursor-pointer"
                        src="assets/images/logo/logo-color.png" routerLink="/home">
                    <img alt="logo"
                        class="hidden dark:flex w-24 cursor-pointer"
                        src="assets/images/logo/logo-color.png" routerLink="/home">
                </div>
                <img alt="logo"
                    class="flex lg:hidden w-20 cursor-pointer"
                    src="assets/images/logo/logo-color.png" routerLink="/home">
            </div>
            <!-- Menu principal (centrado en la franja superior) -->
            <fuse-horizontal-navigation
                class="mx-auto"
                [name]="'mainNavigation'"
                *ngIf="navigation && navigation.horizontal !== undefined"
                [navigation]="navigation.horizontal"></fuse-horizontal-navigation>
        </ng-container>


        <!-- Components -->
        <div class="flex px-4 ml-auto md:ml-6 space-x-0.5 sm:space-x-2" *ngIf="navigation && navigation.horizontal !== undefined">

            <notifications class="text-white"></notifications>
            
            <user [showAvatar]="false"></user>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto w-full">
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->
    <div class="relative flex  items-center justify-center w-full h-14 sm:h-10 px-5 md:px-6 z-49 border-t bg-black dark:bg-transparent print:hidden" *ngIf="!isSmallScreen">
        <span class="font-medium text-white px-4 md:px-6">Políticas de cookies</span>
        <span class="font-medium text-white px-4 md:px-6">Políticas de privacidad</span>
        <span class="font-medium text-white px-4 md:px-6">Términos legales</span>
        <span class="font-medium text-white px-4 md:px-6">Términos y condiciones</span>
    </div>

</div>
